import { useCmsHashState } from './useHashState';

const useOpenRewardModal = () => {
  const [queryParams, setQueryParams] = useCmsHashState<RewardModalState>({
    rewardModalProductId: 'string',
    rewardModalComponentKey: 'string',
  });

  const rewardModalProductId = queryParams.rewardModalProductId ?? '';
  const rewardModalComponentKey = queryParams.rewardModalComponentKey ?? '';

  const openModal = (
    rewardModalProductId: string,
    rewardModalComponentKey: string,
  ) => {
    setQueryParams({
      rewardModalProductId,
      rewardModalComponentKey,
    });
    return true;
  };

  const closeModal = () => {
    setQueryParams({
      rewardModalProductId: undefined,
      rewardModalComponentKey: undefined,
    });
    return false;
  };

  return {
    openModal,
    closeModal,
    rewardModalProductId,
    rewardModalComponentKey,
  };
};

export type RewardModalState = {
  rewardModalProductId: string;
  rewardModalComponentKey: string;
};

export default useOpenRewardModal;
